import axiosTokenInstance from 'services/api/backoffice';
import {
  DETAIL_TRANSACTIONS_OPENPAY,
  DETAIL_TRANSACTIONS_OPENPAY_ERROR,
} from '_models/redux/types';

// Action function
export const detailOpenPayAction = (transactions_id) => async (dispatch) => {
  // Endpoint: Try & Catch
  try {
    const response = await axiosTokenInstance.get(
      `api/reports/v2/transactions-details-openpay/${transactions_id}`,
    );

    const { data, status } = response || {};

    dispatch({
      type: DETAIL_TRANSACTIONS_OPENPAY,
      response: data || {},
      status: status || {},
      method: 'get',
    });
  } catch (e) {
    dispatch({
      type: DETAIL_TRANSACTIONS_OPENPAY_ERROR,
      response: e || {},
    });
  }
};
